export default __webpack_public_path__ + "static/media/emptySubjects.8da9655b.svg";